import Vue from 'vue';

export default {
  // 获取我的采购项目列表
  getPurchaseProjectList (pageNum, pageSize) {
    return Vue.axios.get('/api/v1.0/chanquan/center/getPurchaseProjectListByUser/' + pageNum + '/' + pageSize);
  },
  // 我的采购项目详情
  getPurchaseProjectDetail (params) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/echo', {params});
  },
  // 我的采购项目详情
  // getPurchaseDetail (purchaseId) {
  //   return Vue.axios.get('/api/v1.0/chanquan/center/purchaseInfo/' + purchaseId);
  // },
  // 我的采购项目确认书
  getPurchaseConfirmLetter (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/sales/confirmLetter/' + purchaseId);
  },
  // 确认成交书 采购
  confirmApprove (params) {
    return Vue.axios.post('/api/v1.0/chanquan/sales/confirmApprove', params);
  },
  // 确认成交书 供应
  confirmDealBook (params) {
    return Vue.axios.post('/api/v1.0/chanquan/sales/confirmDealBook', params);
  },
  rejectAnnouncement(payload) {
    return Vue.axios.post('/api/v1.0/chanquan/center/rejectAnnouncement', payload);
  },
  // 确认公告-校验
  checkConfirmPurchase (purchaseId) {
    return Vue.axios.get(`/api/v1.0/chanquan/center/checkPurchaseNoticeStartTimeById//${purchaseId}`);
  },
  // 确认公告
  confirmPurchase (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/center/confirmPurchaseProjectById/' + purchaseId);
  },
  // 上传公告照片
  saveAnnouncementInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/uploadFile', payload);
  },
  // 上传公示照片
  savePublicityPic (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/center/purchaseInfo/savePublicityPic', payload);
  },
  // 获取项目的报名审核列表
  getAuditApplyList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/selectSignListByBidId', params);
  },
  // 根据报名id查询报名人详情
  getSignUserInfo (id) {
    return Vue.axios.get('/api/v1.0/chanquan/bid/getSignUserInfoById/' + id);
  },
  // 审批报名人资质
  approveSignQualification (params) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/approveSignQualification', params);
  },
  // 获取我的报名采购标的列表
  getSignUpPurchaseList (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/signPurchaseBidList', payload);
  },
  // 查询支付保证金详情页面
  getMarginPaymentDetail (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/getOrderDetaiByDeposit', payload);
  },
  // 采购报名详情
  getSignUpPurchaseDetail (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/selectPurchaseSignInfo?relationId=' + purchaseId);
  },
  // 支付保证金
  marginPayment (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/bid/paymentFee', payload);
  },
  // 采购文件列表
  getPurchaseFileList (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/supply/selectPurchaseFileList', payload);
  },
  // 获取采购人项目文件信息
  getFileList(id) {
    return Vue.axios.get('/api/v1.0/chanquan/center/getPurchaseFileList/' + id);
  },
  // 获取承包采购项目列表
  getContractingProjectList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/center/supplierJobPurchaseList', params);
  },
  // 获取获取承包采购项目文件
  getContractingFileList (id, type) {
    return Vue.axios.get('/api/v1.0/chanquan/center/projectFileDownload' + '?id=' + id + '&type=' + type);
  },
  // 支付项目款 详情
  paymentProjectFundInfo (purchaseId, transactionType) {
    return Vue.axios.get('/api/v1.0/chanquan/center/paymentProjectFundInfo/' + purchaseId + '/' + transactionType);
  },
  // 支付项目款 提交
  postPaymentFund (params) {
    return Vue.axios.post('/api/v1.0/chanquan/center/paymentProjectFund', params);
  },
  // 供应人 申请签署合同
  postSign (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/center/contracting/applySignContractBySupplier/' + purchaseId);
  },
  // 采购人 申请签署合同
  postSign1 (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/center/contracting/applySignContractByPurchaser/' + purchaseId);
  },
  // 下载合同
  downloadContract (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/center/project/downloadContract/' + purchaseId);
  },
  // 驳回修改或提交合同
  confirmPurchaseContract (purchaseId, confirmStatus, params) {
    return Vue.axios.get('/api/v1.0/chanquan/center/confirmPurchaseContract/'+purchaseId+'/'+confirmStatus, { params });
  },
  // 创建合同  详情
  getContractDetail (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/center/myPurchase/contract/'+ purchaseId);
  },
  // 创建合同  预览
  getContractDetailP (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/center/myPurchase/contractPreview/'+ purchaseId);
  },
  // 创建合同  提交
  getContractDetailPost (params) {
    return Vue.axios.post('/api/v1.0/chanquan/center/myPurchase/contract/create', params);
  },
  // 去竞价
  getEjyToken (bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/user/getBiddingToken/' + bidId);
  },
  // 竞价列表
  selectBidList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/center/project/selectBidTransferTargetPageList', params);
  },
  // 项目结算
  projectSettlementById (projectId) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/projectSettlementById/' + projectId);
  },
  // 工程已完成
  finishedProject (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/center/finishProjectPurchase/' + purchaseId);
  },
  refundOfDeposit(bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/purchaseRefundMargin/' + bidId);
  },
  // 撤销报名
  revocationSignUp (bidId) {
    return Vue.axios.get('/api/v1.0/chanquan/bid/revocationSignUp', { params: { bidId }});
  }
};
